import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_2 = {
  class: "flex gap-2 flex-wrap border-t border-slate-200/60 pt-4"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "mb-6 mx-6"
};
const _hoisted_5 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
};
const _hoisted_6 = {
  key: 1,
  class: "bg-white rounded-2xl border border-dashed border-slate-300 py-16 flex flex-col items-center justify-center"
};
const _hoisted_7 = {
  key: 2,
  class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_10 = {
  class: "min-w-0 flex-1"
};
const _hoisted_11 = {
  class: "flex items-center gap-2.5 mb-1.5"
};
const _hoisted_12 = {
  class: "font-mono text-sm font-semibold text-slate-900 truncate"
};
const _hoisted_13 = {
  class: "flex flex-wrap items-center gap-1.5 text-xs text-slate-500"
};
const _hoisted_14 = {
  class: "bg-slate-100 px-1.5 py-0.5 rounded"
};
const _hoisted_15 = {
  key: 0,
  class: "bg-purple-50 text-purple-700 px-1.5 py-0.5 rounded font-medium"
};
const _hoisted_16 = {
  key: 1,
  class: "bg-primary-50 text-primary-700 px-1.5 py-0.5 rounded font-medium"
};
const _hoisted_17 = {
  key: 2,
  class: "bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded"
};
const _hoisted_18 = {
  key: 3,
  class: "inline-flex items-center px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200 text-xs font-medium"
};
const _hoisted_19 = {
  class: "flex items-start justify-between gap-4"
};
const _hoisted_20 = {
  class: "flex-1 min-w-0"
};
const _hoisted_21 = ["title"];
const _hoisted_22 = {
  class: "text-xs text-slate-500"
};
const _hoisted_23 = ["title"];
const _hoisted_24 = {
  class: "w-40 text-right shrink-0"
};
const _hoisted_25 = {
  class: "text-xl font-bold text-slate-900"
};
const _hoisted_26 = {
  class: "mt-1.5 text-xs text-slate-500"
};
const _hoisted_27 = {
  class: "mt-2"
};
const _hoisted_28 = {
  class: "flex items-center justify-between text-xs text-slate-400 mb-1.5"
};
const _hoisted_29 = {
  class: "font-medium text-slate-600"
};
const _hoisted_30 = {
  class: "h-2 w-full bg-slate-100 rounded-full overflow-hidden"
};
const _hoisted_31 = {
  class: "grid grid-cols-2 gap-4 p-3 bg-slate-50/80 rounded-xl"
};
const _hoisted_32 = {
  class: "mt-2 space-y-0.5 text-xs text-slate-500"
};
const _hoisted_33 = {
  class: "flex justify-between"
};
const _hoisted_34 = {
  class: "money-text"
};
const _hoisted_35 = {
  class: "flex justify-between"
};
const _hoisted_36 = {
  class: "money-text"
};
const _hoisted_37 = {
  class: "space-y-1 text-xs text-slate-500"
};
const _hoisted_38 = {
  class: "flex justify-between"
};
const _hoisted_39 = {
  class: "font-medium text-slate-700"
};
const _hoisted_40 = {
  class: "flex justify-between"
};
const _hoisted_41 = {
  class: "font-medium text-slate-700"
};
const _hoisted_42 = {
  class: "flex justify-between"
};
const _hoisted_43 = {
  class: "font-medium text-slate-700"
};
const _hoisted_44 = {
  class: "flex items-center justify-between gap-3 pt-1"
};
const _hoisted_45 = {
  class: "text-xs text-slate-400 truncate max-w-[55%] flex items-center gap-1.5"
};
const _hoisted_46 = {
  class: "flex items-center gap-2"
};
const _hoisted_47 = ["onClick"];
const _hoisted_48 = ["disabled", "onClick"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = ["onClick"];
const _hoisted_51 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 bg-gradient-to-r from-slate-50 to-white border-b border-slate-100"
};
const _hoisted_52 = {
  class: "flex items-center gap-4"
};
const _hoisted_53 = {
  class: "flex flex-col gap-0.5"
};
const _hoisted_54 = {
  class: "flex items-center gap-3"
};
const _hoisted_55 = {
  key: 0,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold status-badge is-warning border border-amber-200"
};
const _hoisted_56 = {
  class: "text-sm text-slate-500 font-mono"
};
const _hoisted_57 = {
  class: "h-[65vh] overflow-y-auto min-h-0 px-6 py-5 space-y-5"
};
const _hoisted_58 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4"
};
const _hoisted_59 = {
  class: "bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-200"
};
const _hoisted_60 = {
  class: "text-sm font-semibold text-blue-900"
};
const _hoisted_61 = {
  key: 0,
  class: "text-xs text-blue-600 ml-1"
};
const _hoisted_62 = {
  key: 0,
  class: "text-xs text-blue-600 mt-1"
};
const _hoisted_63 = {
  class: "rounded-xl p-4 border border-slate-200 bg-slate-50/60"
};
const _hoisted_64 = {
  class: "text-xl money-text"
};
const _hoisted_65 = {
  class: "rounded-xl p-4 border border-slate-200 bg-slate-50/60"
};
const _hoisted_66 = {
  class: "text-xl money-text"
};
const _hoisted_67 = {
  class: "rounded-xl p-4 border border-slate-200 bg-slate-50/60"
};
const _hoisted_68 = {
  class: "text-xl money-text"
};
const _hoisted_69 = {
  class: "border-b border-slate-200"
};
const _hoisted_70 = {
  class: "flex gap-4"
};
const _hoisted_71 = ["onClick"];
const _hoisted_72 = {
  key: 0,
  class: "space-y-5"
};
const _hoisted_73 = {
  class: "bg-slate-50/80 rounded-xl p-4"
};
const _hoisted_74 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-3"
};
const _hoisted_75 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_76 = {
  class: "text-sm font-medium text-slate-900 font-mono"
};
const _hoisted_77 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_78 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_79 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_80 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_81 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_82 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_83 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_84 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_85 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_86 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_87 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_88 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_89 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_90 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_91 = {
  key: 0,
  class: "mt-3 bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_92 = {
  class: "text-sm text-slate-700"
};
const _hoisted_93 = {
  class: "bg-slate-50/80 rounded-xl p-4"
};
const _hoisted_94 = {
  key: 0,
  class: "flex items-center justify-center py-8"
};
const _hoisted_95 = {
  key: 1,
  class: "text-center py-6 bg-white rounded-lg border border-slate-100"
};
const _hoisted_96 = {
  key: 2,
  class: "space-y-3"
};
const _hoisted_97 = {
  class: "p-3 border-b border-slate-100 bg-gradient-to-r from-blue-50 to-white"
};
const _hoisted_98 = {
  class: "flex items-center justify-between"
};
const _hoisted_99 = {
  class: "flex items-center gap-3"
};
const _hoisted_100 = {
  class: "text-sm font-semibold text-slate-900 font-mono"
};
const _hoisted_101 = {
  class: "text-right"
};
const _hoisted_102 = {
  class: "text-sm font-bold text-emerald-600"
};
const _hoisted_103 = {
  class: "text-xs text-slate-500"
};
const _hoisted_104 = {
  class: "p-3 grid grid-cols-2 md:grid-cols-4 gap-3"
};
const _hoisted_105 = {
  class: "bg-slate-50 rounded-lg p-2"
};
const _hoisted_106 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_107 = {
  key: 0,
  class: "bg-slate-50 rounded-lg p-2"
};
const _hoisted_108 = {
  class: "text-sm font-medium text-slate-900 font-mono truncate"
};
const _hoisted_109 = {
  key: 1,
  class: "bg-slate-50 rounded-lg p-2"
};
const _hoisted_110 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_111 = {
  class: "bg-slate-50/80 rounded-xl p-4"
};
const _hoisted_112 = {
  class: "grid grid-cols-2 md:grid-cols-3 gap-3 mb-4"
};
const _hoisted_113 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_114 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_115 = {
  class: "text-lg money-text"
};
const _hoisted_116 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_117 = {
  class: "text-lg money-text"
};
const _hoisted_118 = {
  key: 0,
  class: "flex items-center justify-center py-8"
};
const _hoisted_119 = {
  key: 1,
  class: "text-center py-6 bg-white rounded-lg border border-slate-100"
};
const _hoisted_120 = {
  key: 2,
  class: "space-y-3"
};
const _hoisted_121 = {
  class: "p-3 border-b border-slate-100 bg-slate-50"
};
const _hoisted_122 = {
  class: "flex items-center justify-between"
};
const _hoisted_123 = {
  class: "flex items-center gap-3"
};
const _hoisted_124 = {
  class: "text-sm font-semibold text-slate-900 font-mono"
};
const _hoisted_125 = {
  class: "text-right"
};
const _hoisted_126 = {
  class: "text-sm money-text"
};
const _hoisted_127 = {
  class: "text-xs text-slate-500"
};
const _hoisted_128 = {
  class: "flex items-center gap-4 mt-2 text-xs text-slate-500"
};
const _hoisted_129 = {
  key: 0
};
const _hoisted_130 = {
  key: 0,
  class: "p-3"
};
const _hoisted_131 = {
  class: "space-y-2"
};
const _hoisted_132 = {
  class: "flex items-center gap-2"
};
const _hoisted_133 = {
  class: "px-2 py-0.5 bg-primary-50 text-primary-700 rounded text-xs font-medium"
};
const _hoisted_134 = {
  class: "text-sm text-slate-900"
};
const _hoisted_135 = {
  class: "text-right"
};
const _hoisted_136 = {
  class: "text-sm font-bold text-slate-900"
};
const _hoisted_137 = {
  class: "text-xs text-slate-500"
};
const _hoisted_138 = {
  key: 0
};
const _hoisted_139 = {
  key: 1,
  class: "space-y-5"
};
const _hoisted_140 = {
  class: "bg-slate-50/80 rounded-xl p-4"
};
const _hoisted_141 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-3"
};
const _hoisted_142 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_143 = {
  class: "text-sm font-medium text-slate-900 font-mono"
};
const _hoisted_144 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_145 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_146 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_147 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_148 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_149 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_150 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_151 = {
  class: "text-sm font-bold text-slate-900"
};
const _hoisted_152 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_153 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_154 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_155 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_156 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_157 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_158 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_159 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_160 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_161 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_162 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_163 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_164 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_165 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_166 = {
  key: 0,
  class: "bg-white rounded-lg p-3 border border-slate-100 col-span-2"
};
const _hoisted_167 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_168 = {
  key: 0,
  class: "text-xs text-slate-500 mt-1"
};
const _hoisted_169 = {
  class: "bg-slate-50/80 rounded-xl p-4"
};
const _hoisted_170 = {
  class: "bg-white rounded-lg p-4 border border-slate-100 mb-3"
};
const _hoisted_171 = {
  class: "flex items-center gap-3 mb-3"
};
const _hoisted_172 = {
  key: 0,
  class: "w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center"
};
const _hoisted_173 = ["src"];
const _hoisted_174 = {
  key: 1,
  class: "w-6 h-6 text-slate-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_175 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_176 = {
  class: "text-xs text-slate-500"
};
const _hoisted_177 = {
  key: 0,
  class: "mb-3"
};
const _hoisted_178 = {
  class: "text-sm text-slate-700 whitespace-pre-wrap"
};
const _hoisted_179 = {
  key: 1,
  class: "mb-3"
};
const _hoisted_180 = {
  class: "text-sm text-slate-700 whitespace-pre-wrap"
};
const _hoisted_181 = {
  key: 2,
  class: "mb-3"
};
const _hoisted_182 = {
  class: "text-sm text-slate-700 whitespace-pre-wrap"
};
const _hoisted_183 = {
  key: 3
};
const _hoisted_184 = {
  class: "text-sm text-slate-700 whitespace-pre-wrap"
};
const _hoisted_185 = {
  key: 2,
  class: "space-y-5"
};
const _hoisted_186 = {
  class: "bg-slate-50/80 rounded-xl p-4"
};
const _hoisted_187 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-3"
};
const _hoisted_188 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_189 = {
  class: "text-sm font-medium text-slate-900 font-mono"
};
const _hoisted_190 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_191 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_192 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_193 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_194 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_195 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_196 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_197 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_198 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_199 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_200 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_201 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_202 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_203 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_204 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_205 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_206 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_207 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_208 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_209 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_210 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_211 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_212 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_213 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_214 = {
  key: 0,
  class: "bg-slate-50/80 rounded-xl p-4"
};
const _hoisted_215 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_216 = {
  class: "text-sm text-slate-700"
};
const _hoisted_217 = {
  key: 1,
  class: "bg-slate-50/80 rounded-xl p-4"
};
const _hoisted_218 = {
  class: "space-y-3"
};
const _hoisted_219 = {
  class: "flex items-start justify-between mb-2"
};
const _hoisted_220 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_221 = {
  class: "grid grid-cols-2 gap-2 text-xs text-slate-500"
};
const _hoisted_222 = {
  key: 0
};
const _hoisted_223 = {
  key: 1
};
const _hoisted_224 = {
  key: 2
};
const _hoisted_225 = {
  key: 3
};
const _hoisted_226 = {
  key: 0,
  class: "mt-2 text-xs text-slate-500"
};
const _hoisted_227 = {
  key: 1,
  class: "mt-2 text-xs text-slate-500"
};
const _hoisted_228 = {
  key: 2,
  class: "bg-slate-50/80 rounded-xl p-4"
};
const _hoisted_229 = {
  class: "bg-white rounded-lg p-3 border border-slate-100"
};
const _hoisted_230 = {
  key: 0,
  class: "mb-2"
};
const _hoisted_231 = {
  class: "flex flex-wrap gap-1"
};
const _hoisted_232 = {
  key: 1
};
const _hoisted_233 = {
  class: "text-sm text-slate-700 whitespace-pre-wrap"
};
const _hoisted_234 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-100 flex justify-between items-center bg-slate-50/50"
};
const _hoisted_235 = {
  class: "flex items-center gap-3"
};
const _hoisted_236 = {
  class: "text-xs text-slate-400"
};
const _hoisted_237 = {
  key: 0,
  class: "flex items-center justify-center py-16"
};
const _hoisted_238 = {
  key: 1,
  class: "flex-1 min-h-0 overflow-y-auto px-6 py-5 space-y-5"
};
const _hoisted_239 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-xl p-4"
};
const _hoisted_240 = {
  class: "flex items-start gap-3"
};
const _hoisted_241 = {
  class: "text-sm text-red-600 mt-1"
};
const _hoisted_242 = {
  class: "bg-slate-50 rounded-xl p-4 border border-slate-200"
};
const _hoisted_243 = {
  class: "grid grid-cols-1 sm:grid-cols-4 gap-3"
};
const _hoisted_244 = {
  class: "text-lg money-text mt-1"
};
const _hoisted_245 = {
  class: "text-lg money-text mt-1"
};
const _hoisted_246 = {
  class: "text-2xl money-text mt-1"
};
const _hoisted_247 = {
  class: "text-lg money-text mt-1"
};
const _hoisted_248 = {
  class: "text-xs text-slate-500 mt-1"
};
const _hoisted_249 = {
  class: "mt-4 pt-4 border-t border-slate-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2"
};
const _hoisted_250 = {
  class: "min-w-0"
};
const _hoisted_251 = {
  class: "text-sm font-semibold text-slate-900 mt-1 truncate"
};
const _hoisted_252 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_253 = {
  class: "px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-xs"
};
const _hoisted_254 = {
  class: "text-xs text-slate-500"
};
const _hoisted_255 = {
  key: 0,
  class: "px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-xs"
};
const _hoisted_256 = {
  key: 0,
  class: "text-xs text-slate-500 mt-3"
};
const _hoisted_257 = {
  class: "space-y-2"
};
const _hoisted_258 = {
  class: "flex items-center justify-between mb-2"
};
const _hoisted_259 = {
  class: "flex items-center gap-2"
};
const _hoisted_260 = {
  class: "px-2 py-1 bg-primary-100 text-primary-700 rounded-lg text-xs font-semibold"
};
const _hoisted_261 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_262 = {
  class: "text-right"
};
const _hoisted_263 = {
  class: "text-lg font-bold text-slate-900"
};
const _hoisted_264 = {
  class: "text-xs text-slate-500"
};
const _hoisted_265 = {
  key: 0
};
const _hoisted_266 = {
  key: 1
};
const _hoisted_267 = {
  class: "grid grid-cols-1 sm:grid-cols-3 gap-2 mt-3"
};
const _hoisted_268 = {
  class: "bg-white rounded-lg px-3 py-2 border border-slate-100"
};
const _hoisted_269 = {
  class: "text-sm font-semibold text-slate-900 mt-1"
};
const _hoisted_270 = {
  class: "bg-white rounded-lg px-3 py-2 border border-slate-100"
};
const _hoisted_271 = {
  class: "text-xs text-slate-500"
};
const _hoisted_272 = {
  class: "bg-white rounded-lg px-3 py-2 border border-slate-100"
};
const _hoisted_273 = {
  class: "text-sm font-semibold text-slate-900 mt-1"
};
const _hoisted_274 = {
  key: 0,
  class: "text-xs text-slate-500 mt-2"
};
const _hoisted_275 = {
  key: 1,
  class: "text-xs text-slate-500 mt-2 pt-2 border-t border-slate-100"
};
const _hoisted_276 = {
  key: 0
};
const _hoisted_277 = {
  class: "rounded-xl border border-slate-200 overflow-hidden bg-white"
};
const _hoisted_278 = {
  class: "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2"
};
const _hoisted_279 = {
  class: "min-w-0"
};
const _hoisted_280 = {
  class: "text-sm font-semibold text-slate-900 truncate"
};
const _hoisted_281 = {
  class: "mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500"
};
const _hoisted_282 = {
  key: 0
};
const _hoisted_283 = {
  class: "shrink-0 px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-xs"
};
const _hoisted_284 = {
  class: "mt-3 grid grid-cols-1 sm:grid-cols-3 gap-2"
};
const _hoisted_285 = {
  class: "bg-slate-50 rounded-lg px-3 py-2"
};
const _hoisted_286 = {
  class: "text-sm font-semibold text-slate-900 mt-1"
};
const _hoisted_287 = {
  class: "bg-slate-50 rounded-lg px-3 py-2"
};
const _hoisted_288 = {
  class: "text-sm font-semibold text-slate-900 mt-1"
};
const _hoisted_289 = {
  class: "bg-slate-50 rounded-lg px-3 py-2"
};
const _hoisted_290 = {
  class: "text-sm font-semibold text-slate-900 mt-1"
};
const _hoisted_291 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-100 flex justify-end gap-3 bg-slate-50/50"
};
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { getBillingPage, executeCommission, getBillingDetail, previewCommission, getBillingPayments, getBillingCommissions } from '@/api/billing';
import { createOrGetCashierByBilling } from '@/api/cashier';
import AppPagination from '@/components/AppPagination.vue';
import CustomerSelector from '@/components/CustomerSelector/index.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';
import RefundApplyModal from '@/components/RefundApplyModal.vue';

// 筛选表单

export default {
  __name: 'CommissionBillingList',
  setup(__props) {
    const searchForm = reactive({
      keyword: '',
      statusType: 2,
      // 默认显示待分账
      customerId: '',
      orderId: '',
      dueDateRange: []
    });

    // 支付 / 分账状态快捷筛选（与后端 statusType 含义保持一致）
    const statusTypeTabs = [{
      value: '',
      label: '全部'
    }, {
      value: 1,
      label: '未支付'
    }, {
      value: 4,
      label: '逾期'
    }, {
      value: 2,
      label: '待分账'
    }, {
      value: 3,
      label: '已分账'
    }];

    // 点击状态标签筛选
    const handleStatusTabClick = value => {
      searchForm.statusType = value;
      handleSearch();
    };
    const loading = ref(false);
    const billingList = ref([]);
    const pagination = reactive({
      current: 1,
      size: 9,
      total: 0,
      pages: 0
    });

    // 详情弹窗
    const showDetailModal = ref(false);
    const currentBill = ref(null);
    const activeDetailTab = ref('basic');
    const detailPayments = ref([]);
    const detailCommissions = ref([]);
    const detailLoading = ref(false);

    // 预览分账弹窗
    const showPreviewModal = ref(false);
    const previewData = ref(null);
    const previewLoading = ref(false);
    const creatingCashierBillingId = ref(null);

    // 详情弹窗 Tab 配置
    const detailTabs = [{
      key: 'basic',
      label: '账单信息'
    }, {
      key: 'order',
      label: '订单与产品'
    }, {
      key: 'customer',
      label: '客户信息'
    }];

    // 支付渠道标签
    const getPayChannelLabel = channel => {
      const map = {
        'WECHAT': '微信',
        'ALIPAY': '支付宝',
        'BANK_TRANSFER': '银行转账',
        'CASH': '现金',
        'OTHER': '其他'
      };
      return map[channel] || channel || '-';
    };

    // 性别标签
    const getGenderLabel = gender => {
      const map = {
        0: '男',
        1: '女',
        2: '未知'
      };
      return map[gender] ?? '-';
    };

    // 订单状态标签
    const getOrderStatusLabel = status => {
      const map = {
        0: '待确认',
        1: '执行中',
        2: '已完成',
        3: '已取消',
        4: '暂停'
      };
      return map[status] ?? '-';
    };

    // 金额格式化
    const formatAmount = value => {
      const num = Number(value);
      const safeNum = Number.isFinite(num) ? num : 0;
      return safeNum.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    };
    const getPreviewNetSeparableAmount = data => data?.netSeparableAmount ?? data?.totalAmount;
    const getPreviewActualAmount = item => item?.actualAmount ?? item?.amount;
    const formatRatePercent = rate => {
      const num = Number(rate);
      if (!Number.isFinite(num)) return '-';
      return `${(num * 100).toFixed(2).replace(/\.?0+$/, '')}%`;
    };
    const getTaxDirectionLabel = direction => {
      const map = {
        DEDUCT: '扣税',
        COLLECT: '代收税费',
        NONE: '税费'
      };
      return map[direction] || '税费';
    };
    const getTaxAmountClass = direction => {
      const map = {
        DEDUCT: 'text-red-600',
        COLLECT: 'text-emerald-600',
        NONE: 'text-slate-700'
      };
      return map[direction] || 'text-slate-700';
    };

    // 回款进度百分比
    const getPaidPercent = bill => {
      const total = Number(bill?.amount) || 0;
      const paid = Number(bill?.paidAmount) || 0;
      if (total <= 0) return '0%';
      const ratio = Math.max(0, Math.min(1, paid / total));
      return `${(ratio * 100).toFixed(0)}%`;
    };

    // 账单状态：0待收 1已收 2逾期 3坏账
    const getBillingStatusLabel = status => {
      const map = {
        0: '待收',
        1: '已收',
        2: '逾期',
        3: '坏账'
      };
      return map[status] ?? '-';
    };
    const getBillingStatusClass = status => {
      const map = {
        0: 'status-badge is-info',
        1: 'status-badge is-success',
        2: 'status-badge is-danger',
        3: 'status-badge is-neutral'
      };
      return map[status] || 'status-badge is-neutral';
    };

    // 根据支付状态 + 账单状态合成更易懂的收款状态
    const getPaymentStatusLabel = bill => {
      if (!bill) return '-';
      const {
        status,
        paymentStatus,
        commissionStatus
      } = bill;

      // 坏账状态
      if (status === 3) return '坏账';

      // 逾期未支付：status=2 且 paymentStatus=UNPAID
      if (status === 2 && paymentStatus === 'UNPAID') return '逾期未支付';

      // 处理空值或未知值
      const ps = paymentStatus?.toUpperCase?.() || '';
      if (ps === 'UNPAID') return '未支付';
      if (ps === 'PARTIALLY_PAID') return '部分支付';
      if (ps === 'PAID') {
        // 已支付：根据分账状态细分
        if (commissionStatus === 2) return '已支付已分账';
        if (commissionStatus === 1) return '已支付部分分账';
        return '已支付';
      }

      // 如果 paymentStatus 为空但 status 已知，推断状态
      if (status === 0) return '未支付';
      if (status === 1) return '已支付';
      if (status === 2) return '逾期未支付';
      return '-';
    };
    const getPaymentStatusClass = bill => {
      const label = getPaymentStatusLabel(bill);
      const map = {
        未支付: 'status-badge is-neutral',
        '逾期未支付': 'status-badge is-danger',
        部分支付: 'status-badge is-warning',
        已支付: 'status-badge is-success',
        已支付已分账: 'status-badge is-success',
        已支付部分分账: 'status-badge is-indigo',
        坏账: 'status-badge is-danger'
      };
      return map[label] || 'status-badge is-neutral';
    };
    const getPaymentStatusDotClass = bill => {
      const label = getPaymentStatusLabel(bill);
      const map = {
        未支付: 'bg-slate-400',
        '逾期未支付': 'bg-red-500',
        部分支付: 'bg-amber-500',
        已支付: 'bg-emerald-500',
        已支付已分账: 'bg-emerald-500',
        已支付部分分账: 'bg-indigo-500',
        坏账: 'bg-red-600'
      };
      return map[label] || 'bg-slate-400';
    };

    // 分账状态：0未分账 1部分分账 2已分账
    const getCommissionStatusLabel = status => {
      const map = {
        0: '未分账',
        1: '部分分账',
        2: '已分账'
      };
      return map[status] ?? '-';
    };
    const getCommissionStatusClass = status => {
      const map = {
        0: 'status-badge is-neutral',
        1: 'status-badge is-indigo',
        2: 'status-badge is-success'
      };
      return map[status] || 'status-badge is-neutral';
    };

    // 规则类型标签
    const getRuleTypeLabel = type => {
      const map = {
        'GLOBAL': '全局规则',
        'FRANCHISEE': '加盟商规则',
        'PRODUCT': '产品规则'
      };
      return map[type] || type || '-';
    };

    // 计算类型标签
    const getCalculateTypeLabel = type => {
      const map = {
        'RATIO': '按比例',
        'FIXED': '固定金额',
        'LADDER': '阶梯计算',
        'MINIMUM': '保底',
        'REMAINDER': '余量分配'
      };
      return map[type] || type || '-';
    };

    // 角色编码标签
    const getRoleCodeLabel = code => {
      const map = {
        'REFERRER': '引入人',
        'FRANCHISEE': '加盟商',
        'PLATFORM': '平台'
      };
      return map[code] || code || '-';
    };
    const getPayProductCodeLabel = code => {
      const map = {
        'PRO_SCAN': '扫码支付',
        'COUNTER': '柜台支付',
        'EBANK': '网银支付',
        'BANK_TRANSFER': '银行转账'
      };
      return map[code] || code || '-';
    };
    const getFeeSourceLabel = source => {
      const map = {
        'MANUAL': '手工配置',
        'LAKALA': '拉卡拉同步',
        'DEFAULT': '默认配置',
        'LAKALA_FEE_CALC': '拉卡拉试算',
        'LAKALA_MERCHANT_BILLING_QUERY': '商户计费查询'
      };
      return map[source] || source || '-';
    };
    const getFeeRoundingModeLabel = mode => {
      const map = {
        'CEILING': '向上取整',
        'HALF_UP': '四舍五入'
      };
      return map[mode] || mode || '-';
    };
    const formatFeeRate = rate => {
      const num = Number(rate);
      if (!Number.isFinite(num)) return '-';
      return `${(num * 100).toFixed(4).replace(/\.?0+$/, '')}%`;
    };
    const getFeeConfigText = item => {
      if (!item) return '-';
      if (item.feeType === 'RATE') return `比例费率 ${formatFeeRate(item.feeRate)}`;
      if (item.feeType === 'FIXED') return `固定通道费 ¥${formatAmount(item.fixedFeeAmount)}`;
      return item.feeType || '-';
    };

    // 支付状态标签
    const getPaymentRecordStatusLabel = status => {
      const map = {
        'PENDING': '待支付',
        'SUCCESS': '支付成功',
        'FAILED': '支付失败',
        'REFUNDED': '已退款'
      };
      return map[status] || status || '-';
    };
    const getPaymentRecordStatusClass = status => {
      const map = {
        'PENDING': 'status-badge is-warning',
        'SUCCESS': 'status-badge is-success',
        'FAILED': 'status-badge is-danger',
        'REFUNDED': 'status-badge is-neutral'
      };
      return map[status] || 'status-badge is-neutral';
    };

    // 支付渠道标签
    const getChannelTypeLabel = channel => {
      const map = {
        'WECHAT': '微信支付',
        'ALIPAY': '支付宝',
        'BANK_CARD': '银行卡',
        'BANK_TRANSFER': '银行转账',
        'CASH': '现金',
        'OTHER': '其他'
      };
      return map[channel] || channel || '-';
    };

    // 分账结算状态标签（主状态）
    const getSettlementStatusLabel = status => {
      const map = {
        0: '待分账',
        1: '分账中',
        2: '分账完成',
        3: '分账失败',
        4: '已取消'
      };
      return map[status] ?? '-';
    };
    const getSettlementStatusClass = status => {
      const map = {
        0: 'status-badge is-warning',
        1: 'status-badge is-info',
        2: 'status-badge is-success',
        3: 'status-badge is-danger',
        4: 'status-badge is-neutral'
      };
      return map[status] || 'status-badge is-neutral';
    };

    // 分账明细状态标签
    const getCommissionItemStatusLabel = status => {
      const map = {
        0: '待结算',
        1: '已结算',
        2: '已取消'
      };
      return map[status] ?? '-';
    };
    const getCommissionItemStatusClass = status => {
      const map = {
        0: 'status-badge is-warning',
        1: 'status-badge is-success',
        2: 'status-badge is-neutral'
      };
      return map[status] || 'status-badge is-neutral';
    };

    // 加载账单列表
    const fetchBillingList = async () => {
      loading.value = true;
      try {
        const params = {
          statusType: searchForm.statusType !== '' ? Number(searchForm.statusType) : undefined,
          customerId: searchForm.customerId ? Number(searchForm.customerId) : undefined,
          orderId: searchForm.orderId ? Number(searchForm.orderId) : undefined,
          keyword: searchForm.keyword || undefined,
          dueDateStart: searchForm.dueDateRange && searchForm.dueDateRange.length > 0 ? searchForm.dueDateRange[0] : undefined,
          dueDateEnd: searchForm.dueDateRange && searchForm.dueDateRange.length > 1 ? searchForm.dueDateRange[1] : undefined,
          page: pagination.current,
          size: pagination.size
        };
        const data = await getBillingPage(params);
        billingList.value = data.records || [];
        pagination.current = data.current;
        pagination.size = data.size;
        pagination.total = data.total;
        pagination.pages = data.pages;
      } catch (error) {
        ElMessage.error(error.message || '获取分账账单列表失败');
      } finally {
        loading.value = false;
      }
    };
    const handleSearch = () => {
      pagination.current = 1;
      fetchBillingList();
    };
    const resetSearch = () => {
      searchForm.keyword = '';
      searchForm.statusType = 2; // 重置回待分账
      searchForm.customerId = '';
      searchForm.orderId = '';
      searchForm.dueDateRange = [];
      pagination.current = 1;
      fetchBillingList();
    };
    const handlePageChange = page => {
      if (page < 1 || pagination.pages && page > pagination.pages) return;
      pagination.current = page;
      fetchBillingList();
    };
    const handlePageSizeChange = size => {
      pagination.size = size;
      pagination.current = 1;
      fetchBillingList();
    };

    // 判断是否可以执行分账：status=1（已支付待分账）且 commissionStatus=0或1
    const canExecuteCommission = bill => {
      if (!bill) return false;
      return bill.status === 1 && (bill.commissionStatus === 0 || bill.commissionStatus === 1);
    };

    // 判断是否可以发起退款：有收款即可退（含部分收账单），权限由后端 403 兜底
    const canRefund = bill => {
      if (!bill) return false;
      return Number(bill.paidAmount) > 0;
    };

    // 发起退款
    const showRefundModal = ref(false);
    const refundBilling = ref(null);
    const handleRefund = bill => {
      refundBilling.value = bill;
      showRefundModal.value = true;
    };
    const handleRefundSuccess = () => {
      showRefundModal.value = false;
      fetchBillingList();
    };

    // 执行分账
    const handleExecuteCommission = async bill => {
      previewLoading.value = true;
      try {
        previewData.value = await previewCommission(bill.id);
        showPreviewModal.value = true;
      } catch (error) {
        ElMessage.error(error.message || '获取分账预览失败');
      } finally {
        previewLoading.value = false;
      }
    };

    // 确认执行分账
    const confirmExecuteCommission = async () => {
      if (!previewData.value || !previewData.value.canExecute) return;
      try {
        await executeCommission({
          billingId: previewData.value.billingId
        });
        ElMessage.success('分账执行成功');
        showPreviewModal.value = false;
        previewData.value = null;
        fetchBillingList();
      } catch (error) {
        ElMessage.error(error.message || '分账执行失败');
      }
    };

    // 关闭预览弹窗
    const closePreviewModal = () => {
      showPreviewModal.value = false;
      previewData.value = null;
    };
    const openCashierPage = async bill => {
      if (!bill?.id) return;
      creatingCashierBillingId.value = bill.id;
      try {
        const created = await createOrGetCashierByBilling(Number(bill.id));
        const cashierNo = created?.cashierNo || '';
        if (!cashierNo) {
          ElMessage.error('收银台创建失败，请稍后重试');
          return;
        }
        bill.cashierNo = cashierNo;
        const targetUrl = `${window.location.origin}/cashier/${cashierNo}`;
        window.open(targetUrl, '_blank');
      } catch (error) {
        ElMessage.error(error?.message || '创建收银台失败，请稍后重试');
      } finally {
        creatingCashierBillingId.value = null;
      }
    };

    // 详情
    const showDetail = async bill => {
      detailLoading.value = true;
      try {
        currentBill.value = await getBillingDetail(bill.id);
        // 并行加载支付记录和分账记录
        const [payments, commissions] = await Promise.all([getBillingPayments(bill.id).catch(() => []), getBillingCommissions(bill.id).catch(() => [])]);
        detailPayments.value = payments || [];
        detailCommissions.value = commissions || [];
      } catch (error) {
        ElMessage.error('获取账单详情失败');
        return;
      } finally {
        detailLoading.value = false;
      }
      showDetailModal.value = true;
      document.body.style.overflow = 'hidden';
    };
    const closeDetail = () => {
      showDetailModal.value = false;
      currentBill.value = null;
      detailPayments.value = [];
      detailCommissions.value = [];
      document.body.style.overflow = '';
    };

    // 键盘事件
    const handleKeydown = e => {
      if (e.key === 'Escape' && showDetailModal.value) {
        closeDetail();
      }
    };
    onMounted(() => {
      fetchBillingList();
      window.addEventListener('keydown', handleKeydown);
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal mx-6 pt-6"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "分账账单"), _createElementVNode("p", {
          class: "list-page-description"
        }, "查看客户账单收款与分账进度，支持按状态、应收日期等多维度筛选。")])])], -1)]))]),
        filters: _withCtx(() => [_createVNode(PageFilterBar, {
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchBillingList,
          class: "mx-6"
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, " 搜索 "), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: resetSearch
          }, " 重置 ")]),
          extra: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusTypeTabs, tab => {
            return _createElementVNode("button", {
              key: tab.value,
              onClick: $event => handleStatusTabClick(tab.value),
              class: _normalizeClass(['px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-200', searchForm.statusType === tab.value ? 'bg-primary-100 text-primary-700 shadow-sm' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'])
            }, _toDisplayString(tab.label), 11, _hoisted_3);
          }), 64))])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.keyword = $event),
            type: "text",
            placeholder: "客户名称 / 账单编号",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchForm.keyword]]), _cache[7] || (_cache[7] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(CustomerSelector, {
            modelValue: searchForm.customerId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.customerId = $event),
            placeholder: "请选择客户",
            class: "selector-compact filter-bar-field"
          }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.orderId = $event),
            type: "number",
            placeholder: "请输入订单ID",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, searchForm.orderId]]), _createVNode(_component_el_date_picker, {
            modelValue: searchForm.dueDateRange,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => searchForm.dueDateRange = $event),
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            class: "filter-bar-field is-wide form-date form-control-sm"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, n => {
          return _createElementVNode("div", {
            key: n,
            class: "bg-white rounded-2xl border border-slate-200/60 p-5 animate-pulse"
          }, [...(_cache[8] || (_cache[8] = [_createElementVNode("div", {
            class: "flex items-start justify-between mb-5"
          }, [_createElementVNode("div", {
            class: "space-y-3"
          }, [_createElementVNode("div", {
            class: "h-4 w-36 bg-slate-200 rounded-lg"
          }), _createElementVNode("div", {
            class: "h-3 w-28 bg-slate-100 rounded-lg"
          })]), _createElementVNode("div", {
            class: "h-7 w-24 bg-slate-100 rounded-full"
          })], -1), _createElementVNode("div", {
            class: "space-y-2.5 mb-5"
          }, [_createElementVNode("div", {
            class: "h-4 w-44 bg-slate-100 rounded-lg"
          }), _createElementVNode("div", {
            class: "h-3 w-32 bg-slate-50 rounded-lg"
          })], -1), _createElementVNode("div", {
            class: "space-y-2"
          }, [_createElementVNode("div", {
            class: "h-3 w-full bg-slate-50 rounded-lg"
          }), _createElementVNode("div", {
            class: "h-3 w-4/5 bg-slate-50 rounded-lg"
          })], -1)]))]);
        }), 64))])) : billingList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[9] || (_cache[9] = [_createElementVNode("div", {
          class: "empty-state-icon"
        }, [_createElementVNode("svg", {
          class: "w-10 h-10 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
        })])], -1), _createElementVNode("h3", {
          class: "empty-state-title"
        }, "暂无分账账单", -1), _createElementVNode("p", {
          class: "text-sm text-slate-500"
        }, "调整筛选条件或创建新账单", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billingList.value, bill => {
          return _openBlock(), _createElementBlock("div", {
            key: bill.id,
            class: "bg-white rounded-2xl border border-slate-200/60 p-5 flex flex-col gap-4 hover:shadow-lg hover:border-slate-300/80 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer group",
            onClick: $event => showDetail(bill)
          }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(bill.orderNo || '-'), 1), _createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium shrink-0", getPaymentStatusClass(bill)])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1.5", getPaymentStatusDotClass(bill)])
          }, null, 2), _createTextVNode(" " + _toDisplayString(getPaymentStatusLabel(bill)), 1)], 2)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, " #" + _toDisplayString(bill.id), 1), bill.periodType ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(bill.periodType), 1)) : _createCommentVNode("", true), bill.periodIndex ? (_openBlock(), _createElementBlock("span", _hoisted_16, " 第" + _toDisplayString(bill.periodIndex) + "期 ", 1)) : _createCommentVNode("", true), bill.billingType ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(bill.billingType), 1)) : _createCommentVNode("", true), bill.isDraft === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, " 草稿 ")) : _createCommentVNode("", true)])])]), _cache[24] || (_cache[24] = _createElementVNode("div", {
            class: "h-px bg-gradient-to-r from-slate-100 via-slate-200 to-transparent"
          }, null, -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[10] || (_cache[10] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1 font-medium uppercase tracking-wide"
          }, " 客户信息 ", -1)), _createElementVNode("div", {
            class: "text-sm font-semibold text-slate-900 truncate mb-0.5",
            title: bill.customerName
          }, _toDisplayString(bill.customerName || '-'), 9, _hoisted_21), _createElementVNode("div", _hoisted_22, _toDisplayString(bill.customerPhone || '暂无手机号'), 1), _createElementVNode("div", {
            class: "text-xs text-slate-400 mt-1 truncate",
            title: bill.productName
          }, _toDisplayString(bill.productName || '-'), 9, _hoisted_23)]), _createElementVNode("div", _hoisted_24, [_cache[12] || (_cache[12] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1 font-medium uppercase tracking-wide"
          }, " 应收金额 ", -1)), _createElementVNode("div", _hoisted_25, _toDisplayString(formatAmount(bill.amount)), 1), _createElementVNode("div", _hoisted_26, " 已收 " + _toDisplayString(formatAmount(bill.paidAmount)), 1), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_cache[11] || (_cache[11] = _createElementVNode("span", null, "回款进度", -1)), _createElementVNode("span", _hoisted_29, _toDisplayString(getPaidPercent(bill)), 1)]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", {
            class: "h-full bg-gradient-to-r from-emerald-400 to-emerald-500 rounded-full transition-all duration-500",
            style: _normalizeStyle({
              width: getPaidPercent(bill)
            })
          }, null, 4)])])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("div", {
            class: "flex items-center gap-1.5 mb-2"
          }, [_createElementVNode("svg", {
            class: "w-3.5 h-3.5 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
          })]), _createElementVNode("span", {
            class: "text-xs font-medium text-slate-500 uppercase tracking-wide"
          }, "分账状态")], -1)), _createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded-lg text-xs font-semibold", getCommissionStatusClass(bill.commissionStatus)])
          }, _toDisplayString(getCommissionStatusLabel(bill.commissionStatus)), 3), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_cache[13] || (_cache[13] = _createElementVNode("span", null, "已分账", -1)), _createElementVNode("span", _hoisted_34, _toDisplayString(formatAmount(bill.commissionSettledAmount)), 1)]), _createElementVNode("div", _hoisted_35, [_cache[14] || (_cache[14] = _createElementVNode("span", null, "待分账", -1)), _createElementVNode("span", _hoisted_36, _toDisplayString(formatAmount(bill.commissionPendingAmount)), 1)])])]), _createElementVNode("div", null, [_cache[19] || (_cache[19] = _createElementVNode("div", {
            class: "flex items-center gap-1.5 mb-2"
          }, [_createElementVNode("svg", {
            class: "w-3.5 h-3.5 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })]), _createElementVNode("span", {
            class: "text-xs font-medium text-slate-500 uppercase tracking-wide"
          }, "时间信息")], -1)), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_cache[16] || (_cache[16] = _createElementVNode("span", null, "应收", -1)), _createElementVNode("span", _hoisted_39, _toDisplayString(bill.dueDate || '-'), 1)]), _createElementVNode("div", _hoisted_40, [_cache[17] || (_cache[17] = _createElementVNode("span", null, "收款", -1)), _createElementVNode("span", _hoisted_41, _toDisplayString(bill.paidTime || '-'), 1)]), _createElementVNode("div", _hoisted_42, [_cache[18] || (_cache[18] = _createElementVNode("span", null, "创建", -1)), _createElementVNode("span", _hoisted_43, _toDisplayString(bill.createTime || '-'), 1)])])])]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_cache[20] || (_cache[20] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5 shrink-0",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z"
          })], -1)), _createTextVNode(" " + _toDisplayString(bill.remark || '暂无备注'), 1)]), _createElementVNode("div", _hoisted_46, [canExecuteCommission(bill) ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "px-3 py-1.5 text-xs text-white bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 rounded-lg font-medium transition-all flex items-center gap-1.5 shadow-sm shadow-amber-500/20",
            onClick: _withModifiers($event => handleExecuteCommission(bill), ["stop"])
          }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
          })], -1), _createTextVNode(" 执行分账 ", -1)]))], 8, _hoisted_47)) : _createCommentVNode("", true), bill.status !== 1 ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "px-3 py-1.5 text-xs text-teal-700 hover:bg-teal-50 disabled:opacity-60 disabled:cursor-not-allowed rounded-lg font-medium transition-colors flex items-center gap-1.5",
            disabled: creatingCashierBillingId.value === bill.id,
            onClick: _withModifiers($event => openCashierPage(bill), ["stop"])
          }, [_cache[22] || (_cache[22] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8c-1.657 0-3 1.12-3 2.5s1.343 2.5 3 2.5 3 1.12 3 2.5S13.657 18 12 18m0-10V6m0 12v-2M5 12a7 7 0 1114 0 7 7 0 01-14 0z"
          })], -1)), _createTextVNode(" " + _toDisplayString(creatingCashierBillingId.value === bill.id ? '创建中...' : '去收银'), 1)], 8, _hoisted_48)) : _createCommentVNode("", true), canRefund(bill) ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "px-3 py-1.5 text-xs text-rose-600 hover:bg-rose-50 rounded-lg font-medium transition-colors flex items-center gap-1.5",
            onClick: _withModifiers($event => handleRefund(bill), ["stop"])
          }, " 退款 ", 8, _hoisted_49)) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "px-3 py-1.5 text-xs text-primary-600 hover:bg-primary-50 rounded-lg font-medium transition-colors flex items-center gap-1.5",
            onClick: _withModifiers($event => showDetail(bill), ["stop"])
          }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1), _createTextVNode(" 详情 ", -1)]))], 8, _hoisted_50)])])], 8, _hoisted_8);
        }), 128))]))]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "is-standalone",
          pagination: pagination,
          "page-sizes": [9, 18, 27],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: showDetailModal.value,
          size: "5xl",
          onClose: closeDetail
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_cache[26] || (_cache[26] = _createElementVNode("div", {
            class: "w-11 h-11 rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center shadow-lg shadow-primary-500/20"
          }, [_createElementVNode("svg", {
            class: "w-5 h-5 text-white",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          })])], -1)), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_cache[25] || (_cache[25] = _createElementVNode("h3", {
            class: "text-lg font-bold text-slate-900"
          }, "账单详情", -1)), _createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold", getBillingStatusClass(currentBill.value?.status)])
          }, _toDisplayString(getBillingStatusLabel(currentBill.value?.status)), 3), currentBill.value?.isDraft === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_55, " 草稿 ")) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_56, "#" + _toDisplayString(currentBill.value?.id) + " · " + _toDisplayString(currentBill.value?.order?.orderNo), 1)])]), _createElementVNode("button", {
            class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors",
            onClick: closeDetail
          }, [...(_cache[27] || (_cache[27] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_cache[28] || (_cache[28] = _createElementVNode("div", {
            class: "text-xs text-blue-600 mb-1 font-medium uppercase tracking-wide"
          }, "账单类型", -1)), _createElementVNode("div", _hoisted_60, [_createTextVNode(_toDisplayString(currentBill.value?.billingType === 'ONCE' ? '一次性' : currentBill.value?.billingType === 'PERIODIC' ? '周期性' : '-') + " ", 1), currentBill.value?.periodType ? (_openBlock(), _createElementBlock("span", _hoisted_61, " (" + _toDisplayString(currentBill.value?.periodType === 'MONTH' ? '月' : currentBill.value?.periodType === 'QUARTER' ? '季度' : currentBill.value?.periodType === 'YEAR' ? '年' : '') + ") ", 1)) : _createCommentVNode("", true)]), currentBill.value?.periodIndex ? (_openBlock(), _createElementBlock("div", _hoisted_62, "第 " + _toDisplayString(currentBill.value?.periodIndex) + " 期", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_63, [_cache[29] || (_cache[29] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1 font-medium"
          }, "应收金额", -1)), _createElementVNode("div", _hoisted_64, "¥" + _toDisplayString(formatAmount(currentBill.value?.amount)), 1)]), _createElementVNode("div", _hoisted_65, [_cache[30] || (_cache[30] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1 font-medium"
          }, "已收金额", -1)), _createElementVNode("div", _hoisted_66, "¥" + _toDisplayString(formatAmount(currentBill.value?.paidAmount)), 1)]), _createElementVNode("div", _hoisted_67, [_cache[31] || (_cache[31] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1 font-medium"
          }, "待分账金额", -1)), _createElementVNode("div", _hoisted_68, "¥" + _toDisplayString(formatAmount(currentBill.value?.commissionPendingAmount)), 1)])]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(detailTabs, tab => {
            return _createElementVNode("button", {
              key: tab.key,
              onClick: $event => activeDetailTab.value = tab.key,
              class: _normalizeClass(['px-1 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px', activeDetailTab.value === tab.key ? 'text-primary-600 border-primary-600' : 'text-slate-500 border-transparent hover:text-slate-700'])
            }, _toDisplayString(tab.label), 11, _hoisted_71);
          }), 64))])]), activeDetailTab.value === 'basic' ? (_openBlock(), _createElementBlock("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_cache[41] || (_cache[41] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-primary-500 rounded-full"
          }), _createTextVNode(" 账单信息 ")], -1)), _createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_cache[32] || (_cache[32] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "账单编号", -1)), _createElementVNode("div", _hoisted_76, _toDisplayString(currentBill.value?.order?.orderNo || '-'), 1)]), _createElementVNode("div", _hoisted_77, [_cache[33] || (_cache[33] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "应收日期", -1)), _createElementVNode("div", _hoisted_78, _toDisplayString(currentBill.value?.dueDate || '-'), 1)]), _createElementVNode("div", _hoisted_79, [_cache[34] || (_cache[34] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "收款时间", -1)), _createElementVNode("div", _hoisted_80, _toDisplayString(currentBill.value?.paidTime || '-'), 1)]), _createElementVNode("div", _hoisted_81, [_cache[35] || (_cache[35] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "支付渠道", -1)), _createElementVNode("div", _hoisted_82, _toDisplayString(getPayChannelLabel(currentBill.value?.payChannel)), 1)]), _createElementVNode("div", _hoisted_83, [_cache[36] || (_cache[36] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "创建人", -1)), _createElementVNode("div", _hoisted_84, _toDisplayString(currentBill.value?.createBy || '-'), 1)]), _createElementVNode("div", _hoisted_85, [_cache[37] || (_cache[37] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "创建时间", -1)), _createElementVNode("div", _hoisted_86, _toDisplayString(currentBill.value?.createTime || '-'), 1)]), _createElementVNode("div", _hoisted_87, [_cache[38] || (_cache[38] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "更新人", -1)), _createElementVNode("div", _hoisted_88, _toDisplayString(currentBill.value?.updateBy || '-'), 1)]), _createElementVNode("div", _hoisted_89, [_cache[39] || (_cache[39] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "更新时间", -1)), _createElementVNode("div", _hoisted_90, _toDisplayString(currentBill.value?.updateTime || '-'), 1)])]), currentBill.value?.remark ? (_openBlock(), _createElementBlock("div", _hoisted_91, [_cache[40] || (_cache[40] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "备注", -1)), _createElementVNode("div", _hoisted_92, _toDisplayString(currentBill.value.remark), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_93, [_cache[47] || (_cache[47] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-blue-500 rounded-full"
          }), _createTextVNode(" 支付记录 ")], -1)), detailLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_94, [...(_cache[42] || (_cache[42] = [_createElementVNode("div", {
            class: "animate-spin w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full"
          }, null, -1)]))])) : !detailPayments.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_95, [...(_cache[43] || (_cache[43] = [_createElementVNode("div", {
            class: "text-slate-400 text-sm"
          }, "暂无支付记录", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_96, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailPayments.value, payment => {
            return _openBlock(), _createElementBlock("div", {
              key: payment.id,
              class: "bg-white rounded-lg border border-slate-100 overflow-hidden"
            }, [_createElementVNode("div", _hoisted_97, [_createElementVNode("div", _hoisted_98, [_createElementVNode("div", _hoisted_99, [_createElementVNode("span", _hoisted_100, _toDisplayString(payment.paymentNo || '-'), 1), _createElementVNode("span", {
              class: _normalizeClass(["px-2 py-0.5 rounded text-xs font-medium", getPaymentRecordStatusClass(payment.status)])
            }, _toDisplayString(getPaymentRecordStatusLabel(payment.status)), 3)]), _createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, "¥" + _toDisplayString(formatAmount(payment.amount)), 1), _createElementVNode("div", _hoisted_103, _toDisplayString(payment.paidTime || payment.createTime), 1)])])]), _createElementVNode("div", _hoisted_104, [_createElementVNode("div", _hoisted_105, [_cache[44] || (_cache[44] = _createElementVNode("div", {
              class: "text-xs text-slate-500 mb-1"
            }, "支付渠道", -1)), _createElementVNode("div", _hoisted_106, _toDisplayString(getChannelTypeLabel(payment.channelType)), 1)]), payment.channelOrderNo ? (_openBlock(), _createElementBlock("div", _hoisted_107, [_cache[45] || (_cache[45] = _createElementVNode("div", {
              class: "text-xs text-slate-500 mb-1"
            }, "渠道订单号", -1)), _createElementVNode("div", _hoisted_108, _toDisplayString(payment.channelOrderNo), 1)])) : _createCommentVNode("", true), payment.payScene ? (_openBlock(), _createElementBlock("div", _hoisted_109, [_cache[46] || (_cache[46] = _createElementVNode("div", {
              class: "text-xs text-slate-500 mb-1"
            }, "支付场景", -1)), _createElementVNode("div", _hoisted_110, _toDisplayString(payment.payScene), 1)])) : _createCommentVNode("", true)])]);
          }), 128))]))]), _createElementVNode("div", _hoisted_111, [_cache[54] || (_cache[54] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-amber-500 rounded-full"
          }), _createTextVNode(" 分账信息 ")], -1)), _createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_cache[48] || (_cache[48] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "分账状态", -1)), _createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded-lg text-xs font-semibold", getCommissionStatusClass(currentBill.value?.commissionStatus)])
          }, _toDisplayString(getCommissionStatusLabel(currentBill.value?.commissionStatus)), 3)]), _createElementVNode("div", _hoisted_114, [_cache[49] || (_cache[49] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "已分账金额", -1)), _createElementVNode("div", _hoisted_115, "¥" + _toDisplayString(formatAmount(currentBill.value?.commissionSettledAmount)), 1)]), _createElementVNode("div", _hoisted_116, [_cache[50] || (_cache[50] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "待分账金额", -1)), _createElementVNode("div", _hoisted_117, "¥" + _toDisplayString(formatAmount(currentBill.value?.commissionPendingAmount)), 1)])]), detailLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_118, [...(_cache[51] || (_cache[51] = [_createElementVNode("div", {
            class: "animate-spin w-6 h-6 border-2 border-primary-500 border-t-transparent rounded-full"
          }, null, -1)]))])) : !detailCommissions.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_119, [...(_cache[52] || (_cache[52] = [_createElementVNode("div", {
            class: "text-slate-400 text-sm"
          }, "暂无分账记录", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_120, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailCommissions.value, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.settlementId,
              class: "bg-white rounded-lg border border-slate-100 overflow-hidden"
            }, [_createElementVNode("div", _hoisted_121, [_createElementVNode("div", _hoisted_122, [_createElementVNode("div", _hoisted_123, [_createElementVNode("span", _hoisted_124, _toDisplayString(item.settlementNo || '-'), 1), _createElementVNode("span", {
              class: _normalizeClass(["px-2 py-0.5 rounded text-xs font-medium", getSettlementStatusClass(item.status)])
            }, _toDisplayString(getSettlementStatusLabel(item.status)), 3)]), _createElementVNode("div", _hoisted_125, [_createElementVNode("div", _hoisted_126, "¥" + _toDisplayString(formatAmount(item.totalAmount)), 1), _createElementVNode("div", _hoisted_127, _toDisplayString(item.settleTime || item.createTime), 1)])]), _createElementVNode("div", _hoisted_128, [_createElementVNode("span", null, "规则：" + _toDisplayString(item.ruleName || '-'), 1), _createElementVNode("span", null, _toDisplayString(getRuleTypeLabel(item.ruleType)), 1), item.priority ? (_openBlock(), _createElementBlock("span", _hoisted_129, "优先级 " + _toDisplayString(item.priority), 1)) : _createCommentVNode("", true)])]), item.details?.length ? (_openBlock(), _createElementBlock("div", _hoisted_130, [_cache[53] || (_cache[53] = _createElementVNode("div", {
              class: "text-xs font-medium text-slate-500 mb-2"
            }, "分账明细", -1)), _createElementVNode("div", _hoisted_131, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.details, (detail, idx) => {
              return _openBlock(), _createElementBlock("div", {
                key: idx,
                class: "flex items-center justify-between py-2 border-b border-slate-50 last:border-0"
              }, [_createElementVNode("div", _hoisted_132, [_createElementVNode("span", _hoisted_133, _toDisplayString(getRoleCodeLabel(detail.roleCode)), 1), _createElementVNode("span", _hoisted_134, _toDisplayString(detail.roleInstanceName || '-'), 1), _createElementVNode("span", {
                class: _normalizeClass(["px-1.5 py-0.5 rounded text-xs", getCommissionItemStatusClass(detail.status)])
              }, _toDisplayString(getCommissionItemStatusLabel(detail.status)), 3)]), _createElementVNode("div", _hoisted_135, [_createElementVNode("div", _hoisted_136, "¥" + _toDisplayString(formatAmount(detail.amount)), 1), _createElementVNode("div", _hoisted_137, [_createTextVNode(_toDisplayString(getCalculateTypeLabel(detail.calculateType)) + " ", 1), detail.calculateType === 'RATIO' ? (_openBlock(), _createElementBlock("span", _hoisted_138, _toDisplayString(detail.ratio) + "%", 1)) : _createCommentVNode("", true)])])]);
            }), 128))])])) : _createCommentVNode("", true)]);
          }), 128))]))])])) : _createCommentVNode("", true), activeDetailTab.value === 'order' ? (_openBlock(), _createElementBlock("div", _hoisted_139, [_createElementVNode("div", _hoisted_140, [_cache[68] || (_cache[68] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-blue-500 rounded-full"
          }), _createTextVNode(" 订单信息 ")], -1)), _createElementVNode("div", _hoisted_141, [_createElementVNode("div", _hoisted_142, [_cache[55] || (_cache[55] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "订单编号", -1)), _createElementVNode("div", _hoisted_143, _toDisplayString(currentBill.value?.order?.orderNo || '-'), 1)]), _createElementVNode("div", _hoisted_144, [_cache[56] || (_cache[56] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "订单状态", -1)), _createElementVNode("div", _hoisted_145, _toDisplayString(getOrderStatusLabel(currentBill.value?.order?.status)), 1)]), _createElementVNode("div", _hoisted_146, [_cache[57] || (_cache[57] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "订单类型", -1)), _createElementVNode("div", _hoisted_147, _toDisplayString(currentBill.value?.order?.orderType === 'ONCE' ? '一次性' : currentBill.value?.order?.orderType === 'PERIODIC' ? '周期性' : '-'), 1)]), _createElementVNode("div", _hoisted_148, [_cache[58] || (_cache[58] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "分期期数", -1)), _createElementVNode("div", _hoisted_149, _toDisplayString(currentBill.value?.order?.periodCount ? `${currentBill.value.order.periodCount} 期` : '-'), 1)]), _createElementVNode("div", _hoisted_150, [_cache[59] || (_cache[59] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "订单金额", -1)), _createElementVNode("div", _hoisted_151, "¥" + _toDisplayString(formatAmount(currentBill.value?.order?.amount)), 1)]), _createElementVNode("div", _hoisted_152, [_cache[60] || (_cache[60] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "服务开始", -1)), _createElementVNode("div", _hoisted_153, _toDisplayString(currentBill.value?.order?.serviceStart || '-'), 1)]), _createElementVNode("div", _hoisted_154, [_cache[61] || (_cache[61] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "服务结束", -1)), _createElementVNode("div", _hoisted_155, _toDisplayString(currentBill.value?.order?.serviceEnd || '-'), 1)]), _createElementVNode("div", _hoisted_156, [_cache[62] || (_cache[62] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "关联方案", -1)), _createElementVNode("div", _hoisted_157, _toDisplayString(currentBill.value?.order?.planName || '-'), 1)]), _createElementVNode("div", _hoisted_158, [_cache[63] || (_cache[63] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "关联企业", -1)), _createElementVNode("div", _hoisted_159, _toDisplayString(currentBill.value?.order?.companyName || '-'), 1)]), _createElementVNode("div", _hoisted_160, [_cache[64] || (_cache[64] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "规划师", -1)), _createElementVNode("div", _hoisted_161, _toDisplayString(currentBill.value?.order?.ownerUserName || '-'), 1)]), _createElementVNode("div", _hoisted_162, [_cache[65] || (_cache[65] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "执行人员", -1)), _createElementVNode("div", _hoisted_163, _toDisplayString(currentBill.value?.order?.executorName || '-'), 1)]), _createElementVNode("div", _hoisted_164, [_cache[66] || (_cache[66] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "执行进度", -1)), _createElementVNode("div", _hoisted_165, _toDisplayString(currentBill.value?.order?.progress ?? '-') + "%", 1)]), currentBill.value?.order?.currentTaskName ? (_openBlock(), _createElementBlock("div", _hoisted_166, [_cache[67] || (_cache[67] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "当前任务", -1)), _createElementVNode("div", _hoisted_167, _toDisplayString(currentBill.value?.order?.currentTaskName), 1), currentBill.value?.order?.currentTaskStatusDesc ? (_openBlock(), _createElementBlock("div", _hoisted_168, _toDisplayString(currentBill.value?.order?.currentTaskStatusDesc), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_169, [_cache[74] || (_cache[74] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-purple-500 rounded-full"
          }), _createTextVNode(" 产品信息 ")], -1)), _createElementVNode("div", _hoisted_170, [_createElementVNode("div", _hoisted_171, [currentBill.value?.order?.productIcon ? (_openBlock(), _createElementBlock("div", _hoisted_172, [currentBill.value.order.productIcon.startsWith('http') ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: currentBill.value.order.productIcon,
            class: "w-6 h-6",
            alt: ""
          }, null, 8, _hoisted_173)) : (_openBlock(), _createElementBlock("svg", _hoisted_174, [...(_cache[69] || (_cache[69] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          }, null, -1)]))]))])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_175, _toDisplayString(currentBill.value?.order?.productNameSnapshot || '-'), 1), _createElementVNode("div", _hoisted_176, _toDisplayString(currentBill.value?.order?.productCodeSnapshot || '-'), 1)])]), currentBill.value?.order?.productSummarySnapshot ? (_openBlock(), _createElementBlock("div", _hoisted_177, [_cache[70] || (_cache[70] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "产品摘要", -1)), _createElementVNode("div", _hoisted_178, _toDisplayString(currentBill.value.order.productSummarySnapshot), 1)])) : _createCommentVNode("", true), currentBill.value?.order?.serviceScopeSnapshot ? (_openBlock(), _createElementBlock("div", _hoisted_179, [_cache[71] || (_cache[71] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "服务范围", -1)), _createElementVNode("div", _hoisted_180, _toDisplayString(currentBill.value.order.serviceScopeSnapshot), 1)])) : _createCommentVNode("", true), currentBill.value?.order?.deliverablesSnapshot ? (_openBlock(), _createElementBlock("div", _hoisted_181, [_cache[72] || (_cache[72] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "交付物", -1)), _createElementVNode("div", _hoisted_182, _toDisplayString(currentBill.value.order.deliverablesSnapshot), 1)])) : _createCommentVNode("", true), currentBill.value?.order?.noticesSnapshot ? (_openBlock(), _createElementBlock("div", _hoisted_183, [_cache[73] || (_cache[73] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "注意事项", -1)), _createElementVNode("div", _hoisted_184, _toDisplayString(currentBill.value.order.noticesSnapshot), 1)])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), activeDetailTab.value === 'customer' ? (_openBlock(), _createElementBlock("div", _hoisted_185, [_createElementVNode("div", _hoisted_186, [_cache[88] || (_cache[88] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-emerald-500 rounded-full"
          }), _createTextVNode(" 客户信息 ")], -1)), _createElementVNode("div", _hoisted_187, [_createElementVNode("div", _hoisted_188, [_cache[75] || (_cache[75] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户编号", -1)), _createElementVNode("div", _hoisted_189, _toDisplayString(currentBill.value?.customer?.customerNo || '-'), 1)]), _createElementVNode("div", _hoisted_190, [_cache[76] || (_cache[76] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户名称", -1)), _createElementVNode("div", _hoisted_191, _toDisplayString(currentBill.value?.customer?.name || '-'), 1)]), _createElementVNode("div", _hoisted_192, [_cache[77] || (_cache[77] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户性别", -1)), _createElementVNode("div", _hoisted_193, _toDisplayString(getGenderLabel(currentBill.value?.customer?.gender)), 1)]), _createElementVNode("div", _hoisted_194, [_cache[78] || (_cache[78] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户等级", -1)), _createElementVNode("div", _hoisted_195, _toDisplayString(currentBill.value?.customer?.levelName || '-'), 1)]), _createElementVNode("div", _hoisted_196, [_cache[79] || (_cache[79] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户状态", -1)), _createElementVNode("div", _hoisted_197, _toDisplayString(currentBill.value?.customer?.statusName || '-'), 1)]), _createElementVNode("div", _hoisted_198, [_cache[80] || (_cache[80] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户来源", -1)), _createElementVNode("div", _hoisted_199, _toDisplayString(currentBill.value?.customer?.source || '-'), 1)]), _createElementVNode("div", _hoisted_200, [_cache[81] || (_cache[81] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "手机号", -1)), _createElementVNode("div", _hoisted_201, _toDisplayString(currentBill.value?.customer?.phone || '-'), 1)]), _createElementVNode("div", _hoisted_202, [_cache[82] || (_cache[82] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "联系电话", -1)), _createElementVNode("div", _hoisted_203, _toDisplayString(currentBill.value?.customer?.telPhone || '-'), 1)]), _createElementVNode("div", _hoisted_204, [_cache[83] || (_cache[83] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "邮箱", -1)), _createElementVNode("div", _hoisted_205, _toDisplayString(currentBill.value?.customer?.email || '-'), 1)]), _createElementVNode("div", _hoisted_206, [_cache[84] || (_cache[84] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "身份证号", -1)), _createElementVNode("div", _hoisted_207, _toDisplayString(currentBill.value?.customer?.idCard || '-'), 1)]), _createElementVNode("div", _hoisted_208, [_cache[85] || (_cache[85] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "引入人", -1)), _createElementVNode("div", _hoisted_209, _toDisplayString(currentBill.value?.customer?.referrerName || '-'), 1)]), _createElementVNode("div", _hoisted_210, [_cache[86] || (_cache[86] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "所属人", -1)), _createElementVNode("div", _hoisted_211, _toDisplayString(currentBill.value?.customer?.ownerUserName || '-'), 1)]), _createElementVNode("div", _hoisted_212, [_cache[87] || (_cache[87] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "所属部门", -1)), _createElementVNode("div", _hoisted_213, _toDisplayString(currentBill.value?.customer?.ownerDeptName || '-'), 1)])])]), currentBill.value?.customer?.address || currentBill.value?.customer?.detailAddress ? (_openBlock(), _createElementBlock("div", _hoisted_214, [_cache[89] || (_cache[89] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-slate-400 rounded-full"
          }), _createTextVNode(" 地址信息 ")], -1)), _createElementVNode("div", _hoisted_215, [_createElementVNode("div", _hoisted_216, _toDisplayString(currentBill.value?.customer?.address || '') + _toDisplayString(currentBill.value?.customer?.detailAddress || ''), 1)])])) : _createCommentVNode("", true), currentBill.value?.customer?.companies?.length ? (_openBlock(), _createElementBlock("div", _hoisted_217, [_cache[90] || (_cache[90] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-blue-500 rounded-full"
          }), _createTextVNode(" 关联企业 ")], -1)), _createElementVNode("div", _hoisted_218, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentBill.value.customer.companies, company => {
            return _openBlock(), _createElementBlock("div", {
              key: company.id,
              class: "bg-white rounded-lg p-4 border border-slate-100"
            }, [_createElementVNode("div", _hoisted_219, [_createElementVNode("div", _hoisted_220, _toDisplayString(company.companyName), 1), _createElementVNode("span", {
              class: _normalizeClass(["px-2 py-0.5 rounded text-xs font-medium", company.status === 0 ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'])
            }, _toDisplayString(company.status === 0 ? '正常' : '停用'), 3)]), _createElementVNode("div", _hoisted_221, [company.socialCreditCode ? (_openBlock(), _createElementBlock("div", _hoisted_222, "统一社会信用代码：" + _toDisplayString(company.socialCreditCode), 1)) : _createCommentVNode("", true), company.legalPerson ? (_openBlock(), _createElementBlock("div", _hoisted_223, "法定代表人：" + _toDisplayString(company.legalPerson), 1)) : _createCommentVNode("", true), company.registeredCapital ? (_openBlock(), _createElementBlock("div", _hoisted_224, "注册资本：" + _toDisplayString(company.registeredCapital), 1)) : _createCommentVNode("", true), company.establishmentDate ? (_openBlock(), _createElementBlock("div", _hoisted_225, "成立日期：" + _toDisplayString(company.establishmentDate), 1)) : _createCommentVNode("", true)]), company.registeredAddress ? (_openBlock(), _createElementBlock("div", _hoisted_226, " 注册地址：" + _toDisplayString(company.registeredAddress), 1)) : _createCommentVNode("", true), company.businessScope ? (_openBlock(), _createElementBlock("div", _hoisted_227, " 经营范围：" + _toDisplayString(company.businessScope), 1)) : _createCommentVNode("", true)]);
          }), 128))])])) : _createCommentVNode("", true), currentBill.value?.customer?.tags || currentBill.value?.customer?.remark ? (_openBlock(), _createElementBlock("div", _hoisted_228, [_cache[93] || (_cache[93] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-slate-400 rounded-full"
          }), _createTextVNode(" 标签与备注 ")], -1)), _createElementVNode("div", _hoisted_229, [currentBill.value?.customer?.tags ? (_openBlock(), _createElementBlock("div", _hoisted_230, [_cache[91] || (_cache[91] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户标签", -1)), _createElementVNode("div", _hoisted_231, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(String(currentBill.value.customer.tags).split(','), tag => {
            return _openBlock(), _createElementBlock("span", {
              key: tag,
              class: "px-2 py-0.5 bg-primary-50 text-primary-700 rounded text-xs"
            }, _toDisplayString(tag), 1);
          }), 128))])])) : _createCommentVNode("", true), currentBill.value?.customer?.remark ? (_openBlock(), _createElementBlock("div", _hoisted_232, [_cache[92] || (_cache[92] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "客户备注", -1)), _createElementVNode("div", _hoisted_233, _toDisplayString(currentBill.value.customer.remark), 1)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_234, [_createElementVNode("div", _hoisted_235, [canExecuteCommission(currentBill.value) ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-xl text-sm font-medium shadow-sm hover:shadow-md hover:from-amber-600 hover:to-orange-600 active:scale-[0.98] transition-all flex items-center gap-1.5",
            onClick: _cache[4] || (_cache[4] = $event => handleExecuteCommission(currentBill.value))
          }, [...(_cache[94] || (_cache[94] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 10V3L4 14h7v7l9-11h-7z"
          })], -1), _createTextVNode(" 执行分账 ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_236, " 账单 ID: " + _toDisplayString(currentBill.value?.id) + " · 订单 ID: " + _toDisplayString(currentBill.value?.orderId) + " · 客户 ID: " + _toDisplayString(currentBill.value?.customerId), 1)]), _createElementVNode("button", {
            class: "px-5 py-2.5 border border-slate-200 text-slate-700 rounded-xl text-sm font-medium hover:bg-white hover:border-slate-300 active:scale-[0.98] transition-all",
            onClick: closeDetail
          }, " 关闭 ")])]),
          _: 1
        }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: showPreviewModal.value,
          size: "4xl",
          "panel-class": "max-h-[calc(100vh-2rem)]",
          scrollable: false,
          onClose: closePreviewModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex-shrink-0 flex items-center justify-between px-6 py-4 bg-gradient-to-r from-amber-50 to-white border-b border-amber-100"
          }, [_cache[96] || (_cache[96] = _createElementVNode("div", {
            class: "flex items-center gap-3"
          }, [_createElementVNode("div", {
            class: "w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center shadow-lg shadow-amber-500/20"
          }, [_createElementVNode("svg", {
            class: "w-5 h-5 text-white",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 10V3L4 14h7v7l9-11h-7z"
          })])]), _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-bold text-slate-900"
          }, "分账预览"), _createElementVNode("p", {
            class: "text-sm text-slate-500"
          }, "请确认分账明细后再执行")])], -1)), _createElementVNode("button", {
            class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors",
            onClick: closePreviewModal
          }, [...(_cache[95] || (_cache[95] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), previewLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_237, [...(_cache[97] || (_cache[97] = [_createElementVNode("div", {
            class: "animate-spin w-8 h-8 border-4 border-amber-500 border-t-transparent rounded-full"
          }, null, -1)]))])) : previewData.value ? (_openBlock(), _createElementBlock("div", _hoisted_238, [!previewData.value.canExecute ? (_openBlock(), _createElementBlock("div", _hoisted_239, [_createElementVNode("div", _hoisted_240, [_cache[99] || (_cache[99] = _createElementVNode("svg", {
            class: "w-5 h-5 text-red-500 shrink-0 mt-0.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createElementVNode("div", null, [_cache[98] || (_cache[98] = _createElementVNode("div", {
            class: "font-medium text-red-800"
          }, "无法执行分账", -1)), _createElementVNode("div", _hoisted_241, _toDisplayString(previewData.value.reason), 1)])])])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_242, [_createElementVNode("div", _hoisted_243, [_createElementVNode("div", null, [_cache[100] || (_cache[100] = _createElementVNode("div", {
            class: "text-xs text-slate-500 font-medium"
          }, "支付总额", -1)), _createElementVNode("div", _hoisted_244, "¥" + _toDisplayString(formatAmount(previewData.value.grossPaidAmount)), 1)]), _createElementVNode("div", null, [_cache[101] || (_cache[101] = _createElementVNode("div", {
            class: "text-xs text-slate-500 font-medium"
          }, "通道费", -1)), _createElementVNode("div", _hoisted_245, "¥" + _toDisplayString(formatAmount(previewData.value.channelFeeAmount)), 1)]), _createElementVNode("div", null, [_cache[102] || (_cache[102] = _createElementVNode("div", {
            class: "text-xs text-slate-500 font-medium"
          }, "净可分账金额", -1)), _createElementVNode("div", _hoisted_246, "¥" + _toDisplayString(formatAmount(getPreviewNetSeparableAmount(previewData.value))), 1)]), _createElementVNode("div", null, [_cache[103] || (_cache[103] = _createElementVNode("div", {
            class: "text-xs text-slate-500 font-medium"
          }, "引入人税费", -1)), _createElementVNode("div", _hoisted_247, "¥" + _toDisplayString(formatAmount(previewData.value.taxSummary?.totalTaxAmount)), 1), _createElementVNode("div", _hoisted_248, "固定税率 " + _toDisplayString(formatRatePercent(previewData.value.taxSummary?.referrerTaxRate)), 1)])]), _createElementVNode("div", _hoisted_249, [_createElementVNode("div", _hoisted_250, [_cache[104] || (_cache[104] = _createElementVNode("div", {
            class: "text-xs text-slate-500 font-medium"
          }, "匹配规则", -1)), _createElementVNode("div", _hoisted_251, _toDisplayString(previewData.value.ruleName), 1)]), _createElementVNode("div", _hoisted_252, [_createElementVNode("span", _hoisted_253, _toDisplayString(getRuleTypeLabel(previewData.value.ruleType)), 1), _createElementVNode("span", _hoisted_254, "优先级 " + _toDisplayString(previewData.value.priority), 1), previewData.value.taxSummary ? (_openBlock(), _createElementBlock("span", _hoisted_255, " 税费归属：" + _toDisplayString(getRoleCodeLabel(previewData.value.taxSummary.receiverRoleCode)), 1)) : _createCommentVNode("", true)])]), previewData.value.amountBaseDesc ? (_openBlock(), _createElementBlock("div", _hoisted_256, _toDisplayString(previewData.value.amountBaseDesc), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_cache[108] || (_cache[108] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-primary-500 rounded-full"
          }), _createTextVNode(" 分账明细 ")], -1)), _createElementVNode("div", _hoisted_257, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewData.value.details, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "bg-slate-50 rounded-xl p-4 border border-slate-100"
            }, [_createElementVNode("div", _hoisted_258, [_createElementVNode("div", _hoisted_259, [_createElementVNode("span", _hoisted_260, _toDisplayString(getRoleCodeLabel(item.roleCode)), 1), _createElementVNode("span", _hoisted_261, _toDisplayString(item.roleInstanceName || '-'), 1)]), _createElementVNode("div", _hoisted_262, [_createElementVNode("div", _hoisted_263, "¥" + _toDisplayString(formatAmount(getPreviewActualAmount(item))), 1), _cache[105] || (_cache[105] = _createElementVNode("div", {
              class: "text-xs text-slate-500"
            }, "实际分账", -1)), _createElementVNode("div", _hoisted_264, [_createTextVNode(_toDisplayString(getCalculateTypeLabel(item.calculateType)) + " ", 1), item.calculateType === 'RATIO' ? (_openBlock(), _createElementBlock("span", _hoisted_265, _toDisplayString(item.ratio) + "%", 1)) : item.calculateType === 'FIXED' ? (_openBlock(), _createElementBlock("span", _hoisted_266, "¥" + _toDisplayString(formatAmount(item.ratio)), 1)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_267, [_createElementVNode("div", _hoisted_268, [_cache[106] || (_cache[106] = _createElementVNode("div", {
              class: "text-xs text-slate-500"
            }, "规则金额", -1)), _createElementVNode("div", _hoisted_269, "¥" + _toDisplayString(formatAmount(item.amount)), 1)]), _createElementVNode("div", _hoisted_270, [_createElementVNode("div", _hoisted_271, _toDisplayString(getTaxDirectionLabel(item.taxDirection)), 1), _createElementVNode("div", {
              class: _normalizeClass(["text-sm font-semibold mt-1", getTaxAmountClass(item.taxDirection)])
            }, " ¥" + _toDisplayString(formatAmount(item.taxAmount)), 3)]), _createElementVNode("div", _hoisted_272, [_cache[107] || (_cache[107] = _createElementVNode("div", {
              class: "text-xs text-slate-500"
            }, "税率", -1)), _createElementVNode("div", _hoisted_273, _toDisplayString(formatRatePercent(item.taxRate)), 1)])]), item.taxDescription ? (_openBlock(), _createElementBlock("div", _hoisted_274, _toDisplayString(item.taxDescription), 1)) : _createCommentVNode("", true), item.description ? (_openBlock(), _createElementBlock("div", _hoisted_275, _toDisplayString(item.description), 1)) : _createCommentVNode("", true)]);
          }), 128))])]), previewData.value.paymentItems?.length ? (_openBlock(), _createElementBlock("div", _hoisted_276, [_cache[112] || (_cache[112] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
          }, [_createElementVNode("span", {
            class: "w-1.5 h-4 bg-amber-500 rounded-full"
          }), _createTextVNode(" 支付与通道费 ")], -1)), _createElementVNode("div", _hoisted_277, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewData.value.paymentItems, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: item.paymentOrderId || item.paymentOrderNo || index,
              class: "p-4 border-b border-slate-100 last:border-b-0"
            }, [_createElementVNode("div", _hoisted_278, [_createElementVNode("div", _hoisted_279, [_createElementVNode("div", _hoisted_280, _toDisplayString(item.paymentOrderNo || '-'), 1), _createElementVNode("div", _hoisted_281, [_createElementVNode("span", null, _toDisplayString(getPayProductCodeLabel(item.payProductCode)), 1), _createElementVNode("span", null, _toDisplayString(getFeeConfigText(item)), 1), item.feeRoundingMode ? (_openBlock(), _createElementBlock("span", _hoisted_282, _toDisplayString(getFeeRoundingModeLabel(item.feeRoundingMode)), 1)) : _createCommentVNode("", true)])]), _createElementVNode("span", _hoisted_283, _toDisplayString(getFeeSourceLabel(item.feeSource)), 1)]), _createElementVNode("div", _hoisted_284, [_createElementVNode("div", _hoisted_285, [_cache[109] || (_cache[109] = _createElementVNode("div", {
              class: "text-xs text-slate-500"
            }, "支付金额", -1)), _createElementVNode("div", _hoisted_286, "¥" + _toDisplayString(formatAmount(item.paidAmount)), 1)]), _createElementVNode("div", _hoisted_287, [_cache[110] || (_cache[110] = _createElementVNode("div", {
              class: "text-xs text-slate-500"
            }, "通道费", -1)), _createElementVNode("div", _hoisted_288, "¥" + _toDisplayString(formatAmount(item.channelFeeAmount)), 1)]), _createElementVNode("div", _hoisted_289, [_cache[111] || (_cache[111] = _createElementVNode("div", {
              class: "text-xs text-slate-500"
            }, "净可分账", -1)), _createElementVNode("div", _hoisted_290, "¥" + _toDisplayString(formatAmount(item.netSeparableAmount)), 1)])])]);
          }), 128))])])) : _createCommentVNode("", true)], 64))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_291, [_createElementVNode("button", {
            class: "px-5 py-2.5 border border-slate-200 text-slate-700 rounded-xl text-sm font-medium hover:bg-white hover:border-slate-300 active:scale-[0.98] transition-all",
            onClick: closePreviewModal
          }, " 取消 "), previewData.value?.canExecute ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "px-5 py-2.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-xl text-sm font-medium shadow-sm hover:shadow-md hover:from-amber-600 hover:to-orange-600 active:scale-[0.98] transition-all flex items-center gap-1.5",
            onClick: confirmExecuteCommission
          }, [...(_cache[113] || (_cache[113] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1), _createTextVNode(" 确认执行 ", -1)]))])) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"])])), _createVNode(RefundApplyModal, {
          visible: showRefundModal.value,
          billing: refundBilling.value,
          onClose: _cache[5] || (_cache[5] = $event => showRefundModal.value = false),
          onSuccess: handleRefundSuccess
        }, null, 8, ["visible", "billing"])]),
        _: 1
      });
    };
  }
};